<template lang="pug">
.main
    .move-light.background
        .container-xl(style="max-width: 1400px")
            .row.no-gutters
                .col-12
                    .main-view-web()
                        .row
                            .col-12.col-md-6
                                
                                h1(style="max-width: 500px; font-size: 2.5em") Increase collaboration in your corporation  
                            
                            .col-12.col-md-6
                                
                                p(style="max-width: 500px; font-size: 1.25em")
                                    . 
                                        <u>Collaboration is key</u>  in a digital economy with increasing complexity and information decentralization. 
                                        The startup & tech ecosystem is relevant for every corporate, whether you are looking to partner, invest or predict future market shifts. 
                                p(style="max-width: 500px; font-size: 1.25em")
                                    The Ecosystem Manager is the all-in-one tool for corporates that are looking to strategically manage their ecosystem.
                        
                            //.col-12.col-md-4
                                b-card()
                                    h2 Request a free demo
                                    b-form(@submit.stop.prevent="send(form)")
                                        b-form-group(label="Name")
                                            b-input(type="text", v-model="form.name", required)
                                        b-form-group(label="Email")
                                            b-input(type="email", v-model="form.email", required)
                                        b-check(required, name="ps1" id="ps1", v-model="form.accept")
                                            label(for="ps1").small(style="text-transform: none; font-weight: normal; margin-top: 2px") I accept the <a href="/web/imprint" target="_blank" style="text-decoration:underline; text-transform: none; color: black">data privacy statement</a>
                                            
                                        
                                        div(v-if="result")
                                            .text-muted Thanks. Click below to choose a demo slot. We'll get in touch with you.
                                            b-button(variant="primary", href="https://calendly.com/sebastian-voigt/hy-esm-45-mins" target="_blank").mt-3.form-control Book demo slot
                                        div(v-if="!result")
                                            b-button(type="submit", variant="primary").mt-3.form-control Request Demo


   


    .container-xl
        .row.no-gutters
            .col-12
                .main-view
                
                    .row
                            .col-2.d-none.d-md-block
                            .col-12.col-md-4
                                .float-right
                                    div(style="background-color: white; max-width: 600px").p-1.shadow
                                        img(src="/EcosystemSimilarity.gif").img-fluid
                            
                            .col-12.col-md-4
                                label Trend analysis
                                h2 Create and follow topics
                                p Stay up to date on topics that have a high strategic priority for you and increase the efficiency of your trendscouting approach. Create topics, include relevant search words and assign related startups to your topics.

                            .col-2.d-none.d-md-block
                            
    
    .container-xl
        .row.no-gutters
            .col-12
                .main-view
                
                    .row
                            .col-2.d-none.d-md-block
                            .col-12.col-md-4
                                .float-right
                                    div(style="background-color: white; max-width: 600px").p-1.shadow
                                        img(src="/KanbanMove1.gif").img-fluid
                               
                            .col-12.col-md-4
                                label Scouting
                                h2 Scout for startups
                                p Find relevant startups using our similar search feature and our advanced search queries. Search by location, stage, funding, keyword or sustainability metrics. 

                            .col-2.d-none.d-md-block
    .container-xl
        .row.no-gutters
            .col-12
                .main-view
                
                    .row
                            .col-2.d-none.d-md-block
                            .col-12.col-md-4
                                .float-right
                                    div(style="background-color: white; max-width: 600px").p-1.shadow
                                        img(src="/plugin.gif").img-fluid
                            
                            .col-12.col-md-4
                                label Team work
                                h2 Keep track of your startups relations
                                p Manage startups within a topic on the Kanban board. Assign responsibilities for startups to your colleagues within the Kanban board. Reach out to startups in a structured and systematic approach with our automated survey function.
                            .col-2.d-none.d-md-block
    
    .container-xl
        .row.no-gutters
            .col-12
                .main-view
                
                    .row
                            .col-2.d-none.d-md-block
                            .col-12.col-md-4
                                .float-right
                                    div(style="background-color: white; max-width: 600px").p-1.shadow
                                        img(src="/plugin.gif").img-fluid
                            
                            .col-12.col-md-4
                                label Team work
                                h2 Keep track of your startups relations
                                p Manage startups within a topic on the Kanban board. Assign responsibilities for startups to your colleagues within the Kanban board. Reach out to startups in a structured and systematic approach with our automated survey function.
                            .col-2.d-none.d-md-block
    
    .container-xl
        .row.no-gutters
            .col-12
                .main-view
                
                    .row
                            .col-2.d-none.d-md-block
                            .col-12.col-md-4
                                .float-right
                                    div(style="background-color: white; max-width: 600px").p-1.shadow
                                        img(src="/plugin.gif").img-fluid
                            
                            .col-12.col-md-4
                                label Team work
                                h2 Keep track of your startups relations
                                p Manage startups within a topic on the Kanban board. Assign responsibilities for startups to your colleagues within the Kanban board. Reach out to startups in a structured and systematic approach with our automated survey function.
                            .col-2.d-none.d-md-block


    .container
        .row.no-gutters
            .col-12
                .main-view-web(style="max-width: 1440px;").m-auto
                    .row
                        .col-12.col-md-4
                            .text-center.mt-4
                                img(src="/streamline-icon-database-check@140x140.png").adicon
                                h2.text-center Secure server & backups
                            

                        .col-12.col-md-4
                            .text-center.mt-4
                                img(src="/streamline-icon-server-lock@140x140.png").adicon
                                h2.text-center Hosting in Germany

                            
                        .col-12.col-md-4
                            .text-center.mt-4
                                img(src="/streamline-icon-shield-check@140x140.png").adicon
                                h2.text-center GDPR compliant
    Footer()
            
</template>

<script>

  
import Vue from 'vue'
import User from '@/components/User'
import Footer from '@/views/website/Footer'
import Config from '@/config'

export default {
  name: 'Index',
  props: {
    title: String,
    
  },


  data: function () {
      return {
          selectAll: false,
          form: {name: "", organization: "", tel: "", email: ""},
          result: null
      }
  },

  mounted: function() {
     
  },

  methods: {
      send(form) {
          Vue.http.post(Config.config.base_host+'/demo_request', form).then(res => {
            this.result = res;
            this.form = {name: "", organization: "", tel: "", email: ""};
          });
      }
      
  },
  computed: {
    
  },
  components: {
      User,
      Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    body {
        background-color: #fff;
    }
</style>
<style scoped lang="scss">
    @import '@/_vars.scss';

    .btn-outline-secondary {
        color: $light;
        border-color: $light;
    }
    h1 {
        font-family: "IBM Plex Serif" !important;
        font-weight: 800;
        font-size: 2em;   
    }
    h2 {
        font-family: "IBM Plex Serif" !important;
        font-weight: 800;
        font-size: 1.5em;   
    }


    .icon {
        max-width: 25px;
    }

    .footer {
      
        background-color: $primary;
        color: $light !important;
        a {
            color: $light;
        }
        label {
            opacity: 0.6;
        }
        h1 {
            font-family: "IBM Plex Serif" !important;
            font-weight: 800;
            color: $light !important;
        }
    }
    .move {
        position: relative;
        color: $secondary;
        h2 {
            color: $light;
        }
        background-image: linear-gradient(53deg, #003C50 0%, #003C50 64%, #000000 100%);
        overflow: hidden;
    }

    .move:before {
        content: ' ';
        display: block;
        position: absolute;
        left: 50%;
        top: 0;
        width: 50%;
        height: 100%;
        z-index: 1;
        opacity: 0.1;
        background-image: url('/hy_pattern_weiß_rgb.png');
        //background-repeat: no-repeat;
        background-position: 10% 0;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }

    .move-light {
        color: $light;
        h1 {color: $light;}
        background-image: linear-gradient(53deg, #003C50 25%, #003C50 75%, #003C50 100%);
        overflow: hidden;

        @media (max-width: 800px) {
            background-image: linear-gradient(53deg, #003C50 25%, #003C50 75%, #003C50 100%);
            h1 {color: $light;}
        }

    }

  

    .move-light:before {
        content: ' ';
        display: block;
        position: absolute;
        left: 50%;
        top: 0;
        width: 50%;
        height: 100%;
        z-index: -100;
        opacity: 0.1;
        background-image: url('/hy_pattern_weiß_rgb.png');
        //background-repeat: no-repeat;
        background-position: 10% 0;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }



    .main-view-web {
        padding: 30px;
        padding-top: 60px;
        padding-bottom: 60px;
        
    }

    .adicon {
        
        padding: $pad;
        height: 100px;
        
    }

    .red {
        color: #ff595e;
    }

    .lblue {
        color: #d2dee8;
    }

    .azure {
        color: #25b3d2
    }

    .yellow {
        color: #f7d864;
    
    }

    .purple {
        color: #6e6eb3;
    }

    .green {
        color: #47be98;
    }

</style>
